<template>
  <div class="home-container" :style="backgroundStyle">
    <v-container fluid class="pa-0 dashboard-scroll-container" v-if="isShipmentAdmin || isParkingAdmin || canSeeSecurityCards || isParkAdmin">      <v-layout row wrap>
        <!-- Overlay for better readability if needed -->
        <div class="dashboard-overlay"></div>
        
        <v-flex xs12 class="dashboard-content pa-5">
          <!-- Header -->
          <div class="text-xs-center mb-5 white--text home-greeting-header">
            <div class="home-greeting-label">{{ greetingMessage }},</div>
            <div class="home-greeting-name">{{ getProfile.first_name }} {{ getProfile.last_name }}</div>
            <div class="home-greeting-date">{{ currentDate }}</div>
          </div>

          <!-- Dashboard Row -->
          <v-layout row wrap v-if="isShipmentAdmin" class="mb-5">
            <!-- Column 1: Shipment Counters (Replacing Occupancy for this context) -->
            <v-flex xs12 md4 class="pa-4">
              <v-card class="dashboard-card elevation-4 rounded-lg trans-card">
                <v-card-title class="pa-3 white--text primary">
                    <v-icon left dark>local_shipping</v-icon>
                    <span class="title">Estatus Embarques</span>
                </v-card-title>
                <v-card-text class="pa-3">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div class="text-xs-center mb-3">
                                <span class="display-3 font-weight-bold primary--text">{{ totalShipments }}</span>
                                <div class="subheading grey--text">Total Hoy</div>
                            </div>
                        </v-flex>
                        <v-flex xs4 class="text-xs-center">
                            <v-icon color="success" large>check_circle</v-icon>
                            <div class="headline font-weight-bold success--text">{{ shipmentStats.released }}</div>
                            <div class="caption">Liberados</div>
                        </v-flex>
                        <v-flex xs4 class="text-xs-center">
                            <v-icon color="warning" large>access_time</v-icon>
                            <div class="headline font-weight-bold warning--text">{{ shipmentStats.inProcess }}</div>
                            <div class="caption">En Proceso</div>
                        </v-flex>
                         <v-flex xs4 class="text-xs-center">
                            <v-icon color="error" large>warning</v-icon>
                            <div class="headline font-weight-bold error--text">{{ shipmentStats.delayed }}</div>
                            <div class="caption">Retraso</div>
                        </v-flex>
                    </v-layout>
                     <v-divider class="my-3"></v-divider>
                     <v-list dense class="transparent">
                         <v-list-tile>
                             <v-list-tile-content>EN SITIO (Planta)</v-list-tile-content>
                             <v-list-tile-action><strong class="title">{{ shipmentStats.onSite }}</strong></v-list-tile-action>
                         </v-list-tile>
                          <v-list-tile>
                             <v-list-tile-content>Programados Semana</v-list-tile-content>
                             <v-list-tile-action><strong class="title">{{ shipmentStats.weeklyTotal }}</strong></v-list-tile-action>
                         </v-list-tile>
                     </v-list>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- Column 2: Activity Chart -->
            <v-flex xs12 md4 class="pa-4">
              <v-card class="dashboard-card elevation-4 rounded-lg trans-card" style="height: 100%;">
                <v-card-title class="pa-3 white--text primary">
                    <v-icon left dark>bar_chart</v-icon>
                    <span class="title">Actividad Embarques</span>
                    <v-spacer></v-spacer>
                    <v-btn-toggle v-model="chartFilter" mandatory class="transparent-toggle" dark>
                        <v-btn flat small value="week">Semana</v-btn>
                        <v-btn flat small value="month">Mes</v-btn>
                    </v-btn-toggle>
                </v-card-title>
                <v-card-text class="pa-3" style="position: relative; height: 300px;">
                     <canvas id="activityChart"></canvas>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- Column 3: Alerts / Notifications or Quick Actions -->
            <v-flex xs12 md4 class="pa-4">
              <v-card class="dashboard-card elevation-4 rounded-lg trans-card">
                 <v-card-title class="pa-3 white--text primary">
                    <v-icon left dark>notifications</v-icon>
                    <span class="title">Avisos Recientes</span>
                </v-card-title>
                <v-card-text class="pa-0">
                    <v-list two-line class="transparent">
                        <div v-for="(item, index) in alerts" :key="`alert-row-${index}`">
                            <v-list-tile>
                                <v-list-tile-avatar>
                                    <v-icon :class="[item.color + '--text']">{{ item.icon }}</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <div class="caption grey--text">{{ item.time }}</div>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-divider v-if="index + 1 < alerts.length"></v-divider>
                        </div>
                    </v-list>
                </v-card-text>
              </v-card>
               <!-- Mini Chart for Quick Stats -->
               <v-card class="mt-3 dashboard-card elevation-4 rounded-lg trans-card">
                   <v-card-text class="pa-2">
                       <div class="d-flex align-center justify-space-between">
                           <div>
                               <div class="caption grey--text">Eficiencia Semanal</div>
                               <div class="headline font-weight-bold">{{ efficiencyPercent }}%</div>
                           </div>
                           <div style="width: 100px; height: 60px;">
                               <canvas id="efficiencyChart"></canvas>
                           </div>
                       </div>
                   </v-card-text>
               </v-card>
            </v-flex>

          </v-layout>

          <!-- Dashboard Row Estacionamiento -->
          <v-layout row wrap v-if="isParkingAdmin">
            <!-- Column 1: Estatus Estacionamiento -->
            <v-flex xs12 md4 class="pa-4">
              <v-card class="dashboard-card elevation-4 rounded-lg trans-card">
                <v-card-title class="pa-3 white--text primary">
                    <v-icon left dark>local_parking</v-icon>
                    <span class="title">Estatus Estacionamiento</span>
                </v-card-title>
                <v-card-text class="pa-3">
                    <!-- Total -->
                    <div class="text-xs-center mb-3">
                        <span class="display-3 font-weight-bold primary--text">{{ parkingStats.totalSpaces }}</span>
                        <div class="subheading grey--text">Cajones Totales</div>
                    </div>
                    <!-- Disponibles / Ocupados -->
                    <v-layout row wrap class="mb-2">
                        <v-flex xs6 class="text-xs-center stat-block stat-block--available">
                            <div class="stat-label">Disponibles</div>
                            <div class="stat-value success--text">{{ parkingStats.availableSpaces }}</div>
                        </v-flex>
                        <v-flex xs6 class="text-xs-center stat-block stat-block--occupied">
                            <div class="stat-label">Ocupados</div>
                            <div class="stat-value error--text">{{ parkingStats.occupiedSpaces }}</div>
                        </v-flex>
                    </v-layout>
                    <v-divider class="my-3"></v-divider>
                    <!-- Asignados / Sin asignar -->
                    <div class="caption grey--text text--darken-1 font-weight-medium mb-2 text-xs-center" style="text-transform: uppercase; letter-spacing: 0.5px;">Asignación a Empresas</div>
                    <v-layout row wrap>
                        <v-flex xs6 class="text-xs-center stat-block">
                            <div class="stat-label">Asignados</div>
                            <div class="stat-value primary--text">{{ parkingStats.assignedSpaces }}</div>
                        </v-flex>
                        <v-flex xs6 class="text-xs-center stat-block">
                            <div class="stat-label">Sin Asignar</div>
                            <div class="stat-value grey--text text--darken-2">{{ parkingStats.unassignedSpaces }}</div>
                        </v-flex>
                    </v-layout>
                    <v-divider class="my-3"></v-divider>
                    <v-list dense class="transparent">
                        <v-list-tile>
                            <v-list-tile-content>Accesos Hoy</v-list-tile-content>
                            <v-list-tile-action><strong class="title">{{ parkingStats.todayAccess }}</strong></v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content>Vehículos Adentro</v-list-tile-content>
                            <v-list-tile-action><strong class="title">{{ parkingStats.insideVehicles }}</strong></v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- Column 2: Parking Activity Chart -->
            <v-flex xs12 md4 class="pa-4">
              <v-card class="dashboard-card elevation-4 rounded-lg trans-card" style="height: 100%;">
                <v-card-title class="pa-3 white--text primary">
                    <v-icon left dark>show_chart</v-icon>
                    <span class="title">Actividad Semanal</span>
                    <v-spacer></v-spacer>
                    <v-btn-toggle v-model="parkingChartFilter" mandatory class="transparent-toggle" dark>
                        <v-btn flat small value="week">Semana</v-btn>
                        <v-btn flat small value="month">Mes</v-btn>
                    </v-btn-toggle>
                </v-card-title>
                <v-card-text class="pa-3" style="position: relative; height: 300px;">
                     <canvas id="parkingActivityChart"></canvas>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- Column 3: Alerts & Occupancy Mini Chart -->
            <v-flex xs12 md4 class="pa-4">
              <v-card class="dashboard-card elevation-4 rounded-lg trans-card">
                 <v-card-title class="pa-3 white--text primary">
                    <v-icon left dark>notifications</v-icon>
                    <span class="title">Avisos Recientes</span>
                </v-card-title>
                <v-card-text class="pa-0">
                    <v-list two-line class="transparent" style="min-height: 200px;">
                        <div v-for="(item, index) in parkingAlerts" :key="`parking-alert-row-${index}`">
                            <v-list-tile>
                                <v-list-tile-avatar>
                                    <v-icon :class="[item.color + '--text']">{{ item.icon }}</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <div class="caption grey--text">{{ item.time }}</div>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-divider v-if="index + 1 < parkingAlerts.length"></v-divider>
                        </div>
                        <v-list-tile v-if="parkingAlerts.length === 0">
                            <v-list-tile-avatar>
                                <v-icon class="success--text">check_circle</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>No hay eventualidades</v-list-tile-title>
                                <v-list-tile-sub-title>Operación Normal</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-card-text>
              </v-card>
               <!-- Mini Chart for Quick Stats -->
               <v-card class="mt-3 dashboard-card elevation-4 rounded-lg trans-card">
                   <v-card-text class="pa-2">
                       <div class="d-flex align-center justify-space-between">
                           <div>
                               <div class="caption grey--text">Nivel Ocupación</div>
                               <div class="headline font-weight-bold">{{ parkingOccupancyPercent }}%</div>
                           </div>
                           <div style="width: 100px; height: 60px;">
                               <canvas id="parkingOccupancyChart"></canvas>
                           </div>
                       </div>
                   </v-card-text>
               </v-card>
            </v-flex>
          </v-layout>

                    <!-- Security Active Shifts (Host Company Admin + Security Supervisor Employee) -->
                    <v-layout row wrap v-if="canSeeSecurityCards" class="mb-5">
                        <v-flex xs12 class="pa-4">
                            <v-card class="dashboard-card elevation-4 rounded-lg trans-card">
                                <v-card-title class="pa-3 white--text primary">
                                        <v-icon left dark>verified_user</v-icon>
                                        <span class="title">Turnos Activos de Seguridad</span>
                                        <v-spacer></v-spacer>
                                        <v-btn color="white" class="primary--text" small @click="$router.push('/security/geofences')">
                                            <v-icon left small>map</v-icon>
                                            {{ $t('security_geofences') }}
                                        </v-btn>
                                        <v-btn color="white" class="primary--text" small @click="$router.push('/security/dashboard')">
                                            {{ $t('security_module') }}
                                        </v-btn>
                                </v-card-title>
                                <v-card-text class="pa-3">
                                        <div v-if="hostActiveShifts.loading" class="text-xs-center py-4">
                                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                            <div class="mt-3">Cargando turnos activos...</div>
                                        </div>
                                        <v-alert
                                            v-else-if="hostActiveShifts.noCompanyAssociated"
                                            type="warning"
                                            :value="true"
                                            class="mb-3"
                                        >
                                            {{ hostActiveShifts.errorMessage }}
                                        </v-alert>
                                        <template v-else>
                                        <v-layout row wrap>
                                                <v-flex xs12 sm4 class="pa-2">
                                                        <v-card class="pa-3 text-xs-center">
                                                                <v-icon large color="primary">business</v-icon>
                                                                <div class="headline font-weight-bold primary--text">{{ hostActiveShifts.companyHost || '-' }}</div>
                                                                <div class="caption">Empresa</div>
                                                        </v-card>
                                                </v-flex>
                                                <v-flex xs12 sm4 class="pa-2">
                                                        <v-card class="pa-3 text-xs-center">
                                                                <v-icon large color="info">shield</v-icon>
                                                                <div class="headline font-weight-bold info--text">{{ hostActiveShifts.securityProvider || 'Sin contrato activo' }}</div>
                                                                <div class="caption">Proveedor de Seguridad</div>
                                                        </v-card>
                                                </v-flex>
                                                <v-flex xs12 sm4 class="pa-2">
                                                        <v-card class="pa-3 text-xs-center">
                                                                <v-icon large color="warning">access_time</v-icon>
                                                                <div class="headline font-weight-bold warning--text">{{ hostActiveShifts.totalActiveShifts }}</div>
                                                                <div class="caption">Turnos activos</div>
                                                        </v-card>
                                                </v-flex>
                                        </v-layout>

                                        <v-alert
                                            v-if="hostActiveShifts.totalActiveShifts === 0"
                                            type="info"
                                            :value="true"
                                            class="mt-3"
                                        >
                                            No hay contrato de seguridad activo o no hay turnos activos para tu empresa en este momento.
                                        </v-alert>

                                        <v-list v-else dense class="transparent mt-3">
                                            <v-list-tile v-for="shift in hostActiveShifts.activeShifts.slice(0, 5)" :key="shift.shift_id">
                                                <v-list-tile-avatar>
                                                    <v-icon class="primary--text">person</v-icon>
                                                </v-list-tile-avatar>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{ shift.guard_name }}</v-list-tile-title>
                                                    <v-list-tile-sub-title>
                                                        {{ shift.security_company_name }}
                                                        <span v-if="shift.caseta_name"> | Caseta: {{ shift.caseta_name }}</span>
                                                    </v-list-tile-sub-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <div class="caption grey--text">{{ formatHostShiftDate(shift.start_time) }}</div>
                                                </v-list-tile-action>
                                            </v-list-tile>
                                        </v-list>
                                        </template>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>

          <!-- Park Admin Section -->
          <v-layout row wrap v-if="isParkAdmin" class="mb-5">
            <!-- Park Admin Contract Info -->
            <v-flex xs12 md6 class="pa-4">
              <v-card class="dashboard-card elevation-4 rounded-lg trans-card">
                <v-card-title class="pa-3 white--text primary">
                  <v-icon left dark>business</v-icon>
                  <span class="title">Contrato de Seguridad Activo</span>
                  <v-spacer></v-spacer>
                  <v-btn color="white" class="primary--text" small @click="$router.push('/security/geofences')">
                    <v-icon left small>map</v-icon>
                    {{ $t('security_geofences') }}
                  </v-btn>
                </v-card-title>
                <v-card-text class="pa-3">
                  <div v-if="isLoadingParkAdminData" class="text-xs-center py-4">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    <div class="mt-3">Cargando información...</div>
                  </div>
                  <v-alert v-else-if="parkAdminError" type="error" :value="true">
                    {{ parkAdminError }}
                  </v-alert>
                  <template v-else-if="parkAdminContract">
                    <v-list dense class="transparent">
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ $t('security_company') }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ parkAdminContract.security_company_name }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile class="py-4">
                        <v-list-tile-content>
                          <v-list-tile-title>{{ $t('status') }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-chip color="success" text-color="white" small>
                            {{ parkAdminContract.status_display || parkAdminContract.status }}
                          </v-chip>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ $t('created_at') }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ formatDate(parkAdminContract.created_at) }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </template>
                  <v-alert v-else type="info" :value="true">
                    {{ $t('security_no_active_contracts') }}
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- Active Guards in Caseta -->
            <v-flex xs12 md6 class="pa-4">
              <v-card class="dashboard-card elevation-4 rounded-lg trans-card">
                <v-card-title class="pa-3 white--text primary">
                  <v-icon left dark>security</v-icon>
                  <span class="title">Guardias en Caseta (Activos)</span>
                </v-card-title>
                <v-card-text class="pa-3">
                  <div v-if="isLoadingParkAdminData" class="text-xs-center py-4">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </div>
                  <v-list v-else-if="parkAdminGuards.length > 0" dense class="transparent">
                    <v-list-tile v-for="guard in parkAdminGuards" :key="guard.id">
                      <v-list-tile-avatar>
                        <v-icon class="primary--text">person</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ guard.guard_name }}</v-list-tile-title>
                        <v-list-tile-sub-title>
                          <v-chip x-small color="success" text-color="white" v-if="guard.is_active">
                            {{ $t('active') }}
                          </v-chip>
                          <span class="ml-2">{{ guard.caseta_name || 'Sin caseta' }}</span>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <div class="caption grey--text">{{ formatDate(guard.shift_start) }}</div>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                  <v-alert v-else type="info" :value="true">
                    {{ $t('security_no_active_guards') }}
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

        </v-flex>
      </v-layout>
    </v-container>

    <!-- Security Admin Dashboard -->
    <v-container v-else-if="canSeeSecurityDashboard" fluid class="pa-0 dashboard-scroll-container">
      <v-layout row wrap>
        <!-- Overlay for better readability if needed -->
        <div class="dashboard-overlay"></div>
        
        <v-flex xs12 class="dashboard-content pa-5">
          <!-- Header -->
          <div class="text-xs-center mb-5 white--text home-greeting-header">
            <div class="home-greeting-label">{{ greetingMessage }},</div>
            <div class="home-greeting-name">{{ getProfile.first_name }} {{ getProfile.last_name }}</div>
            <div class="home-greeting-date">{{ currentDate }}</div>
          </div>

          <!-- Security Statistics Row -->
          <v-layout row wrap class="mb-5">
            <!-- Guards Stats Card -->
            <v-flex xs12 md3 class="pa-4">
              <v-card class="dashboard-card elevation-4 rounded-lg trans-card">
                <v-card-title class="pa-3 white--text primary">
                    <v-icon left dark>security</v-icon>
                    <span class="title">{{ $t('security_total_guards') }}</span>
                </v-card-title>
                <v-card-text class="pa-3">
                    <div class="text-xs-center">
                        <span class="display-3 font-weight-bold primary--text">{{ securityStats.totalGuards }}</span>
                        <div class="subheading grey--text">{{ $t('total') }}</div>
                    </div>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- Guards on Shift Card -->
            <v-flex xs12 md3 class="pa-4">
              <v-card class="dashboard-card elevation-4 rounded-lg trans-card">
                <v-card-title class="pa-3 white--text primary">
                    <v-icon left dark>check_circle</v-icon>
                    <span class="title">{{ $t('security_guards_on_shift') }}</span>
                </v-card-title>
                <v-card-text class="pa-3">
                    <div class="text-xs-center">
                        <span class="display-3 font-weight-bold success--text">{{ securityStats.guardsOnShift }}</span>
                        <div class="subheading grey--text">{{ $t('active') }}</div>
                    </div>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- Assigned Clients Card -->
            <v-flex xs12 md3 class="pa-4">
              <v-card class="dashboard-card elevation-4 rounded-lg trans-card">
                <v-card-title class="pa-3 white--text primary">
                    <v-icon left dark>business</v-icon>
                    <span class="title">{{ $t('security_total_clients') }}</span>
                </v-card-title>
                <v-card-text class="pa-3">
                    <div class="text-xs-center">
                        <span class="display-3 font-weight-bold info--text">{{ securityStats.assignedClients }}</span>
                        <div class="subheading grey--text">{{ $t('clients') }}</div>
                    </div>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- Active Shifts Card -->
            <v-flex xs12 md3 class="pa-4">
              <v-card class="dashboard-card elevation-4 rounded-lg trans-card">
                <v-card-title class="pa-3 white--text primary">
                    <v-icon left dark>access_time</v-icon>
                    <span class="title">{{ $t('security_total_shifts') }}</span>
                </v-card-title>
                <v-card-text class="pa-3">
                    <div class="text-xs-center">
                        <span class="display-3 font-weight-bold warning--text">{{ securityStats.activeShifts }}</span>
                        <div class="subheading grey--text">{{ $t('active') }}</div>
                    </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

          <!-- Assigned Clients List -->
          <v-layout row wrap class="mb-5">
            <v-flex xs12 class="pa-4">
              <v-card class="dashboard-card elevation-4 rounded-lg trans-card">
                <v-card-title class="pa-3 white--text primary">
                    <v-icon left dark>corporate_fare</v-icon>
                    <span class="title">{{ $t('security_assigned_clients') }}</span>
                </v-card-title>
                <v-card-text class="pa-3">
                    <v-layout row wrap v-if="securityStats.clientsList.length > 0">
                        <v-flex xs12 sm6 md3 v-for="client in securityStats.clientsList" :key="client.id" class="pa-2">
                            <v-card class="pa-3 text-xs-center">
                                <v-icon large color="info">business</v-icon>
                                <div class="title mt-2">{{ client.name }}</div>
                            </v-card>
                        </v-flex>
                    </v-layout>
                    <v-alert v-else type="info" :value="true">
                        {{ $t('security_no_clients_assigned') }}
                    </v-alert>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container v-else-if="isAnyGuard" fill-height>
        <v-layout align-center justify-center row wrap>
            <div class="text-xs-center white--text home-greeting-header" style="z-index: 2;">
                <div class="home-greeting-label">{{ greetingMessage }},</div>
                <div class="home-greeting-name">{{ getProfile.first_name }}</div>
                <div class="home-greeting-date mb-5">{{ currentDate }}</div>

                <v-card class="dashboard-card elevation-4 rounded-lg mt-5" style="min-width: 340px; max-width: 440px; overflow: hidden;">
                    <!-- Loading state -->
                    <div v-if="isLoadingShift" class="pa-6 text-xs-center">
                        <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
                        <div class="mt-3 subheading grey--text">Comprobando turno...</div>
                    </div>

                    <template v-else>
                        <v-card-title class="pa-3 white--text primary">
                            <v-icon left dark>security</v-icon>
                            <span class="title">Mi Turno</span>
                            <v-spacer></v-spacer>
                            <v-chip :color="myShift ? 'success' : 'grey lighten-1'" text-color="white" small class="font-weight-bold">
                                {{ myShift ? 'Activo' : 'Inactivo' }}
                            </v-chip>
                        </v-card-title>

                        <v-card-text class="pa-4 text-xs-left">
                            <!-- Empresa asignada -->
                            <div v-if="guardDisplayCompany" class="d-flex align-center mb-4">
                                <v-icon color="primary" class="mr-3">business</v-icon>
                                <div>
                                    <div class="caption grey--text">Empresa asignada</div>
                                    <div class="body-2 font-weight-bold">{{ guardDisplayCompany }}</div>
                                </div>
                            </div>
                            <v-alert v-else type="warning" :value="true" class="mb-4">
                                Empresa no vinculada. Contacta al administrador para continuar.
                            </v-alert>

                            <!-- Estado del turno -->
                            <div class="text-xs-center mb-2">
                                <div
                                    class="mx-auto mb-3 d-flex align-center justify-center"
                                    style="width:72px; height:72px; border-radius:50%;"
                                    :style="myShift ? 'background:#E8F5E9;' : 'background:#F5F5F5;'"
                                >
                                    <v-icon size="40" :color="myShift ? 'success' : 'grey lighten-1'">
                                        {{ myShift ? 'security' : 'access_time' }}
                                    </v-icon>
                                </div>
                                <div
                                    class="subheading font-weight-bold"
                                    :class="myShift ? 'success--text' : 'grey--text text--darken-1'"
                                >
                                    {{ myShift ? 'Turno Activo' : 'Sin turno activo' }}
                                </div>
                                <div v-if="!myShift" class="caption grey--text mt-1">
                                    Inicia tu turno para comenzar a registrar eventos.
                                </div>
                            </div>

                            <!-- Detalle del turno activo -->
                            <v-list v-if="myShift" dense class="pa-0 mt-3">
                                <v-list-tile>
                                    <v-list-tile-content>Iniciado</v-list-tile-content>
                                    <v-list-tile-action><strong>{{ formatShiftTime(myShift.start_time) }}</strong></v-list-tile-action>
                                </v-list-tile>
                                <v-divider></v-divider>
                                <v-list-tile>
                                    <v-list-tile-content>Ubicación</v-list-tile-content>
                                    <v-list-tile-action><strong>{{ myShift.location || myShift.caseta_name || 'Sin ubicación' }}</strong></v-list-tile-action>
                                </v-list-tile>
                                <v-divider></v-divider>
                                <v-list-tile>
                                    <v-list-tile-content>Tiempo en turno</v-list-tile-content>
                                    <v-list-tile-action><strong class="primary--text">{{ shiftElapsedTime }}</strong></v-list-tile-action>
                                </v-list-tile>
                            </v-list>

                            <!-- Aviso de vencimiento próximo -->
                            <v-alert
                                v-if="myShift && shiftTimeRemaining && shiftTimeRemaining < (30 * 60 * 1000)"
                                type="warning"
                                :value="true"
                                class="mt-4 mb-0"
                            >
                                Tu turno vence en {{ formatTimeRemaining(shiftTimeRemaining) }}. Finalízalo antes de que se cierre automáticamente.
                            </v-alert>

                            <v-divider class="my-4"></v-divider>

                            <v-btn
                                v-if="!myShift"
                                color="primary"
                                block
                                large
                                round
                                depressed
                                @click="startShift"
                                :loading="isLoadingShift"
                            >
                                <v-icon left>play_arrow</v-icon> Iniciar Turno
                            </v-btn>
                            <v-btn
                                v-else
                                color="error"
                                block
                                large
                                round
                                depressed
                                @click="endShift"
                                :loading="isLoadingShift"
                            >
                                <v-icon left>stop</v-icon> Finalizar Turno
                            </v-btn>

                            <v-btn
                                v-if="myShift"
                                color="primary"
                                outline
                                block
                                large
                                round
                                depressed
                                class="mt-3"
                                @click="$router.push('/security/rounds')"
                            >
                                <v-icon left>assignment</v-icon> {{ $t('security_rounds') }}
                            </v-btn>
                        </v-card-text>
                    </template>
                </v-card>
            </div>
            <div class="dashboard-overlay" :style="backgroundStyle"></div>
        </v-layout>

        <v-dialog v-model="showCasetasDialog" persistent max-width="500px">
            <v-card>
                <v-card-title class="headline primary white--text">
                    Selecciona una Caseta
                </v-card-title>
                <v-card-text class="pa-4">
                    <div v-if="casetasLoading" class="text-xs-center">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        <p class="mt-3">Cargando casetas disponibles...</p>
                    </div>
                    <div v-else-if="availableCasetas && availableCasetas.length > 0">
                        <p class="mb-3 grey--text">Selecciona la caseta donde iniciará el turno:</p>
                        <v-list>
                            <v-list-tile
                                v-for="caseta in availableCasetas"
                                :key="caseta.id"
                                @click="selectedCaseta = caseta.id"
                                :class="{ 'primary white--text': selectedCaseta === caseta.id }"
                                class="mb-2 rounded"
                                style="border: 2px solid #ccc; cursor: pointer;"
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ caseta.nombre }}</v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action v-if="selectedCaseta === caseta.id">
                                    <v-icon color="white">check_circle</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                    </div>
                    <div v-else>
                        <v-alert type="error" :value="true">
                            No hay casetas disponibles. Contacta a tu administrador.
                        </v-alert>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" flat @click="showCasetasDialog = false">
                        Cancelar
                    </v-btn>
                    <v-btn 
                        color="primary" 
                        flat 
                        @click="confirmStartShift(selectedCaseta)"
                        :disabled="!selectedCaseta || casetasLoading"
                    >
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>

    <v-container v-else fill-height class="pa-0" style="position: relative;">
        <!-- Scrim for readability over the background wallpaper -->
        <div class="wallpaper-scrim"></div>

        <v-layout align-center justify-center style="position: relative; z-index: 2;">
            <div class="text-xs-center white--text home-greeting-header">
                <div class="home-greeting-label">{{ greetingMessage }},</div>
                <div class="home-greeting-name">{{ getProfile.first_name }} {{ getProfile.last_name }}</div>
                <div class="home-greeting-date">{{ currentDate }}</div>
            </div>
        </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import 'moment/locale/es';

import axios from 'axios';
import store from '@/store';
import { getElapsedTimeMs, getRemainingTimeMs, formatDuration, hasExceededMaxShiftDuration, MAX_SHIFT_DURATION_MS } from '@/services/shiftValidationService';
import { AUTO_LOGOUT_ON_MAX_SHIFT, VALIDATE_SHIFT_STATUS } from '@/store/modules/security';
export default {
  name: 'Home',
  data() {
    return {
      chartFilter: 'week',
      id_company: null,
      shipmentStats: {
        total: 0,
        released: 0,
        inProcess: 0,
        delayed: 0,
        onSite: 0,
        weeklyTotal: 0
      },
      alerts: [],
      efficiencyPercent: 0,
      currentDate: moment().locale('es').format('dddd, D [de] MMMM [de] YYYY'), 
      activityChartInstance: null,
      efficiencyChartInstance: null,
      // Parking Dashboard specific data
      parkingChartFilter: 'week',
      parkingStats: {
        totalSpaces: 0,
        occupiedSpaces: 0,
        availableSpaces: 0,
        todayAccess: 0,
        insideVehicles: 0,
        assignedSpaces: 0,
        unassignedSpaces: 0
      },
      parkingAlerts: [],
      parkingOccupancyPercent: 0,
      parkingActivityChartInstance: null,
      parkingOccupancyChartInstance: null,
      // Security Dashboard specific data
      securityStats: {
        totalGuards: 0,
        guardsOnShift: 0,
        assignedClients: 0,
        activeShifts: 0,
        clientsList: []
      },
            hostActiveShifts: {
                loading: false,
                companyHost: '',
                securityProvider: '',
                totalActiveShifts: 0,
                activeShifts: [],
                noCompanyAssociated: false,
                errorMessage: ''
            },
      // Security Guard (Roll 9) specific data
      myShift: null,
      isLoadingShift: false,
      showCasetasDialog: false,
      selectedCaseta: null,
      availableCasetas: [],
      casetasLoading: false,
      shiftUpdateInterval: null,
      shiftElapsedTime: '0m',
      shiftTimeRemaining: 0,
      // Park Admin (Roll 4) specific data
      parkAdminContract: null,
      parkAdminGuards: [],
      isLoadingParkAdminData: false,
      parkAdminError: null
    };
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapGetters('security', ['getMyCasetas']),
    isShipmentAdmin() {
        const isAdmin = this.getProfile.roll === 5 || this.getProfile.is_superuser === true;
        return isAdmin && this.getProfile.enable_shipments === true;
    },
    isParkingAdmin() {
        const isAdmin = this.getProfile.roll === 5 || this.getProfile.is_superuser === true;
        return isAdmin && this.getProfile.enable_parking === true;
    },
    isSecurityAdmin() {
        return this.getProfile.roll === 8;
    },
    isSecuritySupervisorEmployee() {
        return this.getProfile.roll === 1 && this.getProfile.security_supervisor === true;
    },
    canSeeSecurityCards() {
        const isAdmin = this.getProfile.roll === 5 || this.getProfile.is_superuser === true;
        return this.getProfile.enable_security === true && (isAdmin || this.isSecuritySupervisorEmployee);
    },
    canSeeSecurityDashboard() {
        return this.isSecurityAdmin;
    },
    isSecurityGuard() {
        return this.getProfile.roll === 9;
    },
    isLegacyGuard() {
        return this.getProfile.roll === 2;
    },
    isAnyGuard() {
        return this.getProfile.roll === 9;
    },
    isParkAdmin() {
        return this.getProfile.roll === 4;
    },
    totalShipments() {
        return this.shipmentStats.total;
    },
        guardDisplayCompany() {
            return this.getProfile.name_company || '';
        },
    greetingMessage() {
      const hour = new Date().getHours();
      if (hour >= 6 && hour < 12) return 'Buenos días';
      if (hour >= 12 && hour < 19) return 'Buenas tardes';
      return 'Buenas noches';
    },
    backgroundStyle() {
      const bg = this.getProfile.wallpaper || require('../assets/bg-login.jpg');
      return {
        backgroundImage: `url(${bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
      };
    }
  },
  watch: {
    isShipmentAdmin: {
      immediate: true,
      handler(val) {
        if (val) this.get_extra_data();
      }
    },
    isParkingAdmin: {
        immediate: true,
        handler(val) {
            if (val) this.get_extra_data();
        }
    },
    isSecurityAdmin: {
        immediate: true,
        handler(val) {
            if (val) this.fetchSecurityData();
        }
    },
    canSeeSecurityCards: {
        immediate: true,
        handler(val) {
            if (val) this.fetchHostActiveShifts();
        }
    },
    isSecurityGuard: {
        immediate: true,
        handler(val) {
            if (val) this.fetchGuardData();
        }
    },
    isLegacyGuard: {
        immediate: true,
        handler(val) {
            if (val) this.fetchGuardData();
        }
    },
    isParkAdmin: {
        immediate: true,
        handler(val) {
            if (val) this.fetchParkAdminData();
        }
    },
    chartFilter(val) {
        if (this.id_company) this.fetchActivityChartData(val);
    },
    parkingChartFilter(val) {
        if (this.id_company) this.fetchParkingActivityChartData(val);
    }
  },
  created() {
    if (this.isShipmentAdmin || this.isParkingAdmin) {
      this.get_extra_data();
                } else if (this.isSecurityAdmin) {
            this.fetchSecurityData();
    }
  },
  destroyed() {
      document.body.style.overflow = '';
      this.stopShiftMonitoring();
      this.$store.commit('security/CLEAR_SHIFT_CHECK_INTERVAL');
  },
  methods: {
      bootstrapDashboards() {
          this.$nextTick(() => {
              if (typeof Chart !== 'undefined') {
                  if (this.isShipmentAdmin) this.initCharts();
                  if (this.isParkingAdmin) setTimeout(this.initParkingCharts, 200);
              } else {
                  setTimeout(this.bootstrapDashboards, 500);
              }
          });
      },
      initCharts() {
          this.renderActivityChart();
          this.renderEfficiencyChart();
      },
      initParkingCharts() {
          this.renderParkingActivityChart();
          this.renderParkingOccupancyChart();
      },
      renderActivityChart(labels, data) {
          const ctx = document.getElementById('activityChart').getContext('2d');
          if (this.activityChartInstance) {
              this.activityChartInstance.destroy();
          }
          this.activityChartInstance = new Chart(ctx, {
              type: 'line',
              data: {
                  labels: labels || ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
                  datasets: [{
                      label: 'Embarques',
                      data: data || [0, 0, 0, 0, 0, 0, 0],
                      backgroundColor: 'rgba(54, 162, 235, 0.2)',
                      borderColor: 'rgba(54, 162, 235, 1)',
                      borderWidth: 2,
                      fill: true,
                      pointBackgroundColor: '#fff',
                      pointBorderColor: 'rgba(54, 162, 235, 1)',
                      pointRadius: 4,
                      tension: 0.3,
                  }]
              },
              options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  legend: { display: false },
                  scales: {
                      yAxes: [{
                          ticks: { beginAtZero: true, precision: 0 }
                      }]
                  }
              }
          });
      },
      async fetchActivityChartData(period) {
          const headers = {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          };
          const today = moment().format('YYYY-MM-DD');
          try {
              const res = await axios.get(
                  'https://empresa-service.intrare.app/shipments/statistics/',
                  { params: { empresa_id: this.id_company, period, date: today }, headers }
              );
              const stats = res.data.statistics;
              let labels, data;
              if (period === 'week') {
                  // Semana: etiquetas de los 7 días (Lun → Dom)
                  labels = stats.chart_labels || ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
                  data   = stats.chart_data  || [0, 0, 0, 0, 0, 0, 0];
              } else {
                  // Mes: etiquetas por semana
                  labels = stats.chart_labels || ['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4'];
                  data   = stats.chart_data  || [0, 0, 0, 0];
              }
              this.renderActivityChart(labels, data);
          } catch (error) {
              console.error('Error fetching activity chart data:', error);
          }
      },
      renderEfficiencyChart() {
          const ctx = document.getElementById('efficiencyChart').getContext('2d');
           this.efficiencyChartInstance = new Chart(ctx, {
              type: 'doughnut',
              data: {
                  labels: ['Eficiencia', 'Restante'],
                  datasets: [{
                      data: [94, 6],
                      backgroundColor: ['#4caf50', '#e0e0e0'],
                      borderWidth: 0
                  }]
              },
              options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  legend: { display: false },
                  cutoutPercentage: 70,
                  tooltips: { enabled: false }
              }
          });
      },
      
      get_extra_data() {
          const config = {
              method: 'get',
              url: 'https://empresa-service.intrare.app/auth/me',
              headers: {
                  'Content-Type': 'application/json',
                  'authorization': 'Token ' + store.getters.getToken
              }
          };
          axios(config)
              .then(response => {
                  this.id_company = response.data.id_company;
                  if(this.isShipmentAdmin) this.fetchDashboardData();
                  if(this.isParkingAdmin) this.fetchParkingDashboardData();
                  if(this.canSeeSecurityCards) this.fetchHostActiveShifts();
                  this.bootstrapDashboards();
              })
              .catch(error => {
                  console.log(error);
              });
      },
      formatHostShiftDate(dateTime) {
          if (!dateTime) return '-';
          return moment(dateTime).locale('es').format('DD/MM/YYYY HH:mm');
      },
      formatDate(dateString) {
          if (!dateString) return 'N/A';
          return moment(dateString).locale('es').format('DD [de] MMMM [de] YYYY HH:mm');
      },
      async fetchDashboardData() {
          const headers = {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          };
          const today = moment().format('YYYY-MM-DD');

          try {
              const [dayRes, weekRes, windowsRes] = await Promise.all([
                  axios.get('https://empresa-service.intrare.app/shipments/statistics/', { params: { empresa_id: this.id_company, period: 'day', date: today }, headers }),
                  axios.get('https://empresa-service.intrare.app/shipments/statistics/', { params: { empresa_id: this.id_company, period: 'week', date: today }, headers }),
                  axios.get('https://empresa-service.intrare.app/shipments/shipping-windows/by_date_range/', { params: { empresa: this.id_company, start_date: today, end_date: today }, headers })
              ]);

              const dayStats = dayRes.data.statistics;
              const weekStats = weekRes.data.statistics;
              const todayWindows = Array.isArray(windowsRes.data) ? windowsRes.data : [];

              // 1. Column 1: Daily Stats & Weekly Total
              this.shipmentStats = {
                  total: dayStats.total || 0,
                  released: (dayStats.liberados || 0) + (dayStats.completados || 0),
                  inProcess: dayStats.en_planta || 0, 
                  delayed: dayStats.en_retraso || 0,
                  onSite: dayStats.en_planta || 0,
                  weeklyTotal: weekStats.total || 0
              };

              // 2. Column 2: Activity Chart — delegado a fetchActivityChartData
              this.fetchActivityChartData(this.chartFilter);

              // 3. Eficiencia Semanal
              let efficiency = 0;
              if (weekStats.total > 0) {
                  efficiency = Math.round((((weekStats.liberados || 0) + (weekStats.completados || 0)) / weekStats.total) * 100);
              }
              this.efficiencyPercent = efficiency;
              if (this.efficiencyChartInstance) {
                  this.efficiencyChartInstance.data.datasets[0].data = [efficiency, 100 - efficiency];
                  this.efficiencyChartInstance.update();
              }

              // 4. Avisos Recientes (Generados en base a embarques del día)
              this.generateAlerts(todayWindows);

          } catch (error) {
              console.error("Error fetching dashboard data:", error);
          }
      },
      generateAlerts(windows) {
          const newAlerts = [];
          const now = moment();
          
          windows.forEach(w => {
             if (w.status === 'EN_RETRASO' || (w.status !== 'LIBERADA' && w.status !== 'COMPLETADA' && w.status !== 'CANCELADA' && moment(`${w.window_date} ${w.estimated_end_time}`).isBefore(now))) {
                 newAlerts.push({
                     title: 'Embarque Retrasado',
                     subtitle: `Planta destino: ${(w.client_name) || 'Desconocido'} en ${(w.loading_area && w.loading_area.name) || 'Área'}`,
                     time: moment(`${w.window_date} ${w.window_time}`).fromNow(),
                     icon: 'error',
                     color: 'error'
                 });
             } else if (w.status === 'EN_SITIO' || w.status === 'EN_PROCESO') {
                 newAlerts.push({
                     title: w.status === 'EN_PROCESO' ? 'Carga en Proceso' : 'En Sitio',
                     subtitle: `Transporte en ${(w.loading_area && w.loading_area.name) || 'Planta'}`,
                     time: 'Actual',
                     icon: w.status === 'EN_PROCESO' ? 'local_shipping' : 'location_on',
                     color: 'warning'
                 });
             } else if (w.status === 'PROGRAMADA' || w.status === 'CONFIRMADA') {
                 const diffHours = moment(`${w.window_date} ${w.window_time}`).diff(now, 'hours');
                 if (diffHours >= 0 && diffHours <= 2) {
                      newAlerts.push({
                         title: 'Embarque Próximo',
                         subtitle: `Programado a las ${w.window_time.substring(0, 5)}`,
                         time: `En ${diffHours === 0 ? moment(`${w.window_date} ${w.window_time}`).diff(now, 'minutes') + ' min' : diffHours + ' h'}`,
                         icon: 'schedule',
                         color: 'info'
                      });
                 }
             }
          });

          // Sort by criticalness (errors first) and limit to max 5 alerts
          const order = { 'error': 1, 'warning': 2, 'info': 3 };
          newAlerts.sort((a, b) => order[a.color] - order[b.color]);
          
          this.alerts = newAlerts.slice(0, 5);
          
          if (this.alerts.length === 0) {
              this.alerts.push({
                 title: 'Sin novedades',
                 subtitle: 'Todo opera con normalidad',
                 time: 'Ahora',
                 icon: 'check_circle',
                 color: 'success'
              });
          }
      },
      renderParkingActivityChart(labels, data) {
          const canvas = document.getElementById('parkingActivityChart');
          if (!canvas) return;
          const ctx = canvas.getContext('2d');
          if (this.parkingActivityChartInstance) this.parkingActivityChartInstance.destroy();
          this.parkingActivityChartInstance = new Chart(ctx, {
              type: 'bar',
              data: {
                  labels: labels || ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
                  datasets: [{
                      label: 'Accesos de Estacionamiento',
                      data: data || [0, 0, 0, 0, 0, 0, 0],
                      backgroundColor: 'rgba(76, 175, 80, 0.6)',
                      borderColor: 'rgba(76, 175, 80, 1)',
                      borderWidth: 1,
                      borderRadius: 4,
                  }]
              },
              options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  legend: { display: false },
                  scales: {
                      yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }]
                  }
              }
          });
      },
      renderParkingOccupancyChart() {
          const canvas = document.getElementById('parkingOccupancyChart');
          if (!canvas) return;
          const ctx = canvas.getContext('2d');
          if (this.parkingOccupancyChartInstance) this.parkingOccupancyChartInstance.destroy();
          this.parkingOccupancyChartInstance = new Chart(ctx, {
              type: 'doughnut',
              data: {
                  labels: ['Ocupado', 'Libre'],
                  datasets: [{
                      data: [0, 100],
                      backgroundColor: ['#f44336', '#e0e0e0'],
                      borderWidth: 0
                  }]
              },
              options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  legend: { display: false },
                  cutoutPercentage: 70,
                  tooltips: { enabled: false }
              }
          });
      },
      async fetchParkingActivityChartData(period) {
          const headers = {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          };
          const today = moment().format('YYYY-MM-DD');
          
          try {
              let startDate, labels = [], data = [];
              
              if (period === 'week') {
                  // Últimos 7 días
                  startDate = moment().subtract(6, 'days').format('YYYY-MM-DD');
                  labels = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
                  
                  const historyRes = await axios.get(
                      'https://empresa-service.intrare.app/Parking/invitations/history/',
                      { headers, params: { start_date: startDate, end_date: today, empresa_id: this.id_company } }
                  );
                  
                  const historyData = Array.isArray(historyRes.data) ? historyRes.data : [];
                  data = [0, 0, 0, 0, 0, 0, 0]; // 7 días
                  
                  // Contar accesos por día
                  historyData.forEach(record => {
                      if (record.entry_time) {
                          const recordDate = moment(record.entry_time);
                          const dayIndex = recordDate.diff(moment(startDate), 'days');
                          if (dayIndex >= 0 && dayIndex < 7) {
                              data[dayIndex]++;
                          }
                      }
                  });
              } else {
                  // Mes: últimas 4 semanas
                  startDate = moment().subtract(28, 'days').format('YYYY-MM-DD');
                  labels = ['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4'];
                  
                  const historyRes = await axios.get(
                      'https://empresa-service.intrare.app/Parking/invitations/history/',
                      { headers, params: { start_date: startDate, end_date: today, empresa_id: this.id_company } }
                  );
                  
                  const historyData = Array.isArray(historyRes.data) ? historyRes.data : [];
                  data = [0, 0, 0, 0]; // 4 semanas
                  
                  // Contar accesos por semana
                  historyData.forEach(record => {
                      if (record.entry_time) {
                          const recordDate = moment(record.entry_time);
                          const weekIndex = Math.floor(recordDate.diff(moment(startDate), 'days') / 7);
                          if (weekIndex >= 0 && weekIndex < 4) {
                              data[weekIndex]++;
                          }
                      }
                  });
              }
              
              this.renderParkingActivityChart(labels, data);
          } catch (error) {
              console.error('Error fetching parking activity chart data:', error);
              // Fallback con datos vacíos en caso de error
              const labels = period === 'week' 
                  ? ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom']
                  : ['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4'];
              const data = period === 'week' ? [0, 0, 0, 0, 0, 0, 0] : [0, 0, 0, 0];
              this.renderParkingActivityChart(labels, data);
          }
      },
      async fetchParkingDashboardData() {
          const headers = {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          };
          try {
              const [availableRes, occupiedRes] = await Promise.all([
                  axios.get('https://empresa-service.intrare.app/Parking/spaces/', { headers, params: { id_section__idEmpresa: this.id_company, status: 'available' } }),
                  axios.get('https://empresa-service.intrare.app/Parking/spaces/', { headers, params: { id_section__idEmpresa: this.id_company, status: 'occupied' } })
              ]);
              
              const availableData = Array.isArray(availableRes.data) ? availableRes.data : [];
              const occupiedData = Array.isArray(occupiedRes.data) ? occupiedRes.data : [];
              const spacesData = [...availableData, ...occupiedData];
              
              const availableSpaces = availableData.length;
              const occupiedSpaces = occupiedData.length;
              const totalSpaces = availableSpaces + occupiedSpaces;
              
              // Asignados: cajones que tienen sección asignada (ligada a un cliente/empresa)
              const assignedSpaces = spacesData.filter(s => s.id_section != null).length;
              const unassignedSpaces = totalSpaces - assignedSpaces;
              
              this.parkingStats.totalSpaces = totalSpaces;
              this.parkingStats.occupiedSpaces = occupiedSpaces;
              this.parkingStats.availableSpaces = availableSpaces;
              this.parkingStats.assignedSpaces = assignedSpaces;
              this.parkingStats.unassignedSpaces = unassignedSpaces;
              
              const occPercent = totalSpaces > 0 ? Math.round((occupiedSpaces / totalSpaces) * 100) : 0;
              this.parkingOccupancyPercent = occPercent;
              
              if (this.parkingOccupancyChartInstance) {
                  this.parkingOccupancyChartInstance.data.datasets[0].data = [occPercent, 100 - occPercent];
                  this.parkingOccupancyChartInstance.update();
              }
              
              try {
                  const today = moment().format('YYYY-MM-DD');
                  const historyRes = await axios.get('https://empresa-service.intrare.app/Parking/invitations/history/', { headers, params: { start_date: today } });
                  const historyData = Array.isArray(historyRes.data) ? historyRes.data : [];
                  this.parkingStats.todayAccess = historyData.length;
                  this.parkingStats.insideVehicles = historyData.filter(h => h.exit_time === null).length;
              } catch(e) {
                  this.parkingStats.todayAccess = 0;
                  this.parkingStats.insideVehicles = 0;
              }
              
              this.fetchParkingActivityChartData(this.parkingChartFilter);
              
              if (occPercent < 50) {
                  this.parkingAlerts = [{ title: 'Todo en orden', subtitle: 'Disponibilidad de cajones óptima.', time: 'Ahora', icon: 'check_circle', color: 'success' }];
              } else {
                  this.parkingAlerts = [{ title: 'Ocupación Alta', subtitle: `Nivel de ocupación al ${occPercent}%`, time: 'Reciente', icon: occPercent > 85 ? 'error' : 'warning', color: occPercent > 85 ? 'error' : 'warning' }];
              }
          } catch (error) {
              console.error("Error fetching parking dashboard data:", error);
          }
      },
      async fetchSecurityData() {
          const headers = {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          };
          try {
              const companyRes = await axios.get('https://empresa-service.intrare.app/security/my-company/', { headers });
              const companyData = companyRes.data || {};

              let guardsData = [];
              let shiftsData = [];
              
              try {
                  const guardsRes = await axios.get('https://empresa-service.intrare.app/security/guards/', { headers });
                  guardsData = Array.isArray(guardsRes.data) ? guardsRes.data : [];
              } catch(e) {}
              
              try {
                  const shiftsRes = await axios.get('https://empresa-service.intrare.app/security/shifts/', { headers });
                  shiftsData = Array.isArray(shiftsRes.data) ? shiftsRes.data.filter(s => s.is_active) : [];
              } catch(e) {}

              this.securityStats.totalGuards = companyData.total_active_guards !== undefined ? companyData.total_active_guards : guardsData.length;
              this.securityStats.guardsOnShift = companyData.guards_on_shift !== undefined ? companyData.guards_on_shift : shiftsData.length;

              // El endpoint /security/my-company/ devuelve el historial de contratos en
              // "company_contracts" (puede incluir varios registros INACTIVE/REJECTED por
              // el mismo cliente); solo contamos los que están ACTIVE.
              const activeContracts = Array.isArray(companyData.company_contracts)
                  ? companyData.company_contracts.filter(contract => contract && contract.status === 'ACTIVE')
                  : [];

              const activeClientsByCompany = new Map();
              activeContracts.forEach(contract => {
                  const companyId = contract.company_id || contract.id;
                  if (!activeClientsByCompany.has(companyId)) {
                      activeClientsByCompany.set(companyId, {
                          id: companyId,
                          name: contract.company_name || 'Cliente',
                          contractStatus: contract.status_display || contract.status || 'Activo'
                      });
                  }
              });

              const activeClientsFromContracts = Array.from(activeClientsByCompany.values());

              const fallbackClients = Array.isArray(companyData.client_companies)
                  ? companyData.client_companies.map(client => ({
                      ...client,
                      id: client.id || client.company_id,
                      name: client.name || client.company_name || 'Cliente'
                  }))
                  : [];

              const normalizedClients = Array.isArray(companyData.company_contracts)
                  ? activeClientsFromContracts
                  : fallbackClients;

              this.securityStats.assignedClients = normalizedClients.length;
              this.securityStats.activeShifts = shiftsData.length;
              this.securityStats.clientsList = normalizedClients;
          } catch (error) {
              console.error("Error fetching security dashboard data:", error);
          }
      },
      async fetchHostActiveShifts() {
          const headers = {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          };

          this.hostActiveShifts.loading = true;

          try {
              const response = await axios.get('https://empresa-service.intrare.app/security/host/active-shifts/', { headers });
              const data = response.data || {};

              this.hostActiveShifts.companyHost = data.company_host || '';
              this.hostActiveShifts.securityProvider = data.security_provider || '';
              this.hostActiveShifts.totalActiveShifts = data.total_active_shifts || 0;
              this.hostActiveShifts.activeShifts = Array.isArray(data.active_shifts) ? data.active_shifts : [];
              this.hostActiveShifts.noCompanyAssociated = false;
              this.hostActiveShifts.errorMessage = '';
          } catch (error) {
              const status = error && error.response ? error.response.status : null;
              const apiMessage = error && error.response && error.response.data
                  ? error.response.data.error
                  : null;

              this.hostActiveShifts.companyHost = '';
              this.hostActiveShifts.securityProvider = '';
              this.hostActiveShifts.totalActiveShifts = 0;
              this.hostActiveShifts.activeShifts = [];

              if (status === 400) {
                  this.hostActiveShifts.noCompanyAssociated = true;
                  this.hostActiveShifts.errorMessage = apiMessage || 'No tienes una empresa asociada.';
              } else {
                  this.hostActiveShifts.noCompanyAssociated = false;
                  this.hostActiveShifts.errorMessage = 'No fue posible obtener los turnos activos de seguridad.';
                  console.error('Error fetching host active shifts:', error);
              }
          } finally {
              this.hostActiveShifts.loading = false;
          }
      },
      fetchGuardData() {
          this.isLoadingShift = true;
          this.$store.dispatch('security/FETCH_ACTIVE_SHIFT', store.getters.getToken)
              .then(activeShift => {
                  // La acción retorna directamente el turno activo o null
                  this.myShift = activeShift;

                  // Si hay turno activo, iniciar monitoreo
                  if (activeShift) {
                      this.updateShiftTime();
                      this.startShiftMonitoring();
                  } else {
                      this.stopShiftMonitoring();
                  }

                  this.isLoadingShift = false;
              })
              .catch(err => {
                  console.error('Error fetching active shift:', err);
                  this.myShift = null;
                  this.stopShiftMonitoring();
                  this.isLoadingShift = false;
              });
      },
      startShiftMonitoring() {
          // Actualizar tiempo cada segundo
          this.shiftUpdateInterval = setInterval(() => {
              this.updateShiftTime();
          }, 1000);
      },
      stopShiftMonitoring() {
          if (this.shiftUpdateInterval) {
              clearInterval(this.shiftUpdateInterval);
              this.shiftUpdateInterval = null;
          }
      },

      startShift() {
          if (this.isAnyGuard) {
              this.fetchCasetas();
              this.showCasetasDialog = true;
          } else {
              this.confirmStartShift(null);
          }
      },
      fetchCasetas() {
          this.casetasLoading = true;
          this.$store.dispatch('security/FETCH_MY_CASETAS', store.getters.getToken)
              .then(resp => {
                  if (resp.casetas && Array.isArray(resp.casetas)) {
                      this.availableCasetas = resp.casetas;
                  } else if (Array.isArray(resp)) {
                      this.availableCasetas = resp;
                  } else if (resp.data && Array.isArray(resp.data)) {
                      this.availableCasetas = resp.data;
                  } else {
                      // Si no tiene casetas, mostrar error
                      this.$store.commit('snackbar_change_message', 'No se encontraron casetas disponibles');
                      this.$store.commit('snackbar_change_color', 'warning');
                      this.$store.commit('snackbar_activate_true');
                      this.availableCasetas = [];
                  }
                  this.casetasLoading = false;
              })
              .catch(err => {
                  this.$store.commit('snackbar_change_message', 'Error al cargar casetas disponibles');
                  this.$store.commit('snackbar_change_color', 'error');
                  this.$store.commit('snackbar_activate_true');
                  this.casetasLoading = false;
                  this.showCasetasDialog = false;
              });
      },
      confirmStartShift(casetaId) {
          // Validar que si es guardia, debe seleccionar caseta
          if (this.isAnyGuard && !casetaId) {
              this.$store.commit('snackbar_change_message', 'Por favor selecciona una caseta');
              this.$store.commit('snackbar_change_color', 'warning');
              this.$store.commit('snackbar_activate_true');
              return;
          }
          
          this.isLoadingShift = true;
          this.showCasetasDialog = false;
          this.$store.dispatch('security/START_SHIFT', { token: store.getters.getToken, casetaId: casetaId })
              .then(resp => {
                  this.myShift = resp;
                  this.selectedCaseta = null;
                  this.$store.commit('snackbar_change_message', 'Turno Iniciado');
                  this.$store.commit('snackbar_change_color', 'success');
                  this.$store.commit('snackbar_activate_true');
                  this.fetchGuardData(); 
              })
              .catch(err => {
                  this.fetchGuardData();
                  this.$store.commit('snackbar_change_message', 'Error al iniciar turno. ¿Ya tienes uno abierto?');
                  this.$store.commit('snackbar_change_color', 'error');
                  this.$store.commit('snackbar_activate_true');
                  this.isLoadingShift = false;
              });
      },
      endShift() {
          if (!this.myShift) return;
          this.isLoadingShift = true;
          this.$store.dispatch('security/DEACTIVATE_ACTIVE_SHIFT', store.getters.getToken)
              .then(result => {
                  this.myShift = null;
                  this.$store.commit('snackbar_change_message', result.detail || 'Turno Finalizado');
                  this.$store.commit('snackbar_change_color', 'success');
                  this.$store.commit('snackbar_activate_true');
                  this.isLoadingShift = false;
                  this.fetchGuardData();
              })
              .catch(err => {
                  const errorMsg = (err.response && err.response.data && err.response.data.detail) || 'No se pudo finalizar el turno';
                  this.$store.commit('snackbar_change_message', errorMsg);
                  this.$store.commit('snackbar_change_color', 'error');
                  this.$store.commit('snackbar_activate_true');
                  this.isLoadingShift = false;
              });
      },
      formatShiftTime(timeString) {
          if (!timeString) return '';
          const d = new Date(timeString);
          return d.toLocaleTimeString(this.$i18n.locale, { hour: '2-digit', minute: '2-digit' });
      },
      updateShiftTime() {
          if (!this.myShift) return;

          const elapsed = getElapsedTimeMs(this.myShift.start_time);
          this.shiftElapsedTime = formatDuration(elapsed);
          this.shiftTimeRemaining = getRemainingTimeMs(this.myShift.start_time);

          // Validar estado del turno
          this.$store.dispatch(`security/${VALIDATE_SHIFT_STATUS}`)

          // Si excedió 24h, iniciar cierre automático
          if (hasExceededMaxShiftDuration(this.myShift.start_time)) {
              this.$store.dispatch(`security/${AUTO_LOGOUT_ON_MAX_SHIFT}`)
          }
      },
      formatTimeRemaining(ms) {
          if (!ms) return '0m';
          const minutes = Math.floor(ms / 60000);
          const seconds = Math.floor((ms % 60000) / 1000);
          if (minutes > 0) return `${minutes}m ${seconds}s`;
          return `${seconds}s`;
      },
      fetchParkAdminData() {
          if (!this.isParkAdmin) return;
          this.isLoadingParkAdminData = true;
          this.parkAdminError = null;
          
          // Obtener contrato activo
          this.fetchActiveParkContract();
      },
      fetchActiveParkContract() {
          const API_BASE_URL = 'https://empresa-service.intrare.app';
          
          // Obtener parkId del perfil del usuario (admin de parque)
          const parkId = this.getProfile.id_park || this.getProfile.park_id || this.getProfile.park || this.getProfile.id_parque;
          
          if (!parkId) {
              console.warn('[Home] Park ID not found in profile, fetching from /parques/');
              this.getParquesToResolveParkId();
              return;
          }
          
          // Proceder con parkId válido
          this.fetchContractsForPark(parkId);
      },
      getParquesToResolveParkId() {
          const API_BASE_URL = 'https://empresa-service.intrare.app';
          const config = {
              method: 'get',
              url: `${API_BASE_URL}/parques/`,
              headers: {
                  'Content-Type': 'application/json',
                  'authorization': `Token ${store.getters.getToken}`
              }
          };
          
          import('axios').then(axios => {
              axios.default(config)
                  .then(resp => {
                      console.log('[Home] Parques response:', resp.data);
                      let parkId = null;
                      
                      // Manejar diferentes estructuras de respuesta
                      if (Array.isArray(resp.data) && resp.data.length > 0) {
                          parkId = resp.data[0].id;
                      } else if (resp.data && resp.data.results && Array.isArray(resp.data.results) && resp.data.results.length > 0) {
                          parkId = resp.data.results[0].id;
                      } else if (resp.data && resp.data.parques && Array.isArray(resp.data.parques) && resp.data.parques.length > 0) {
                          parkId = resp.data.parques[0].id;
                      } else if (resp.data && resp.data.id) {
                          parkId = resp.data.id;
                      }
                      
                      if (parkId) {
                          console.log('[Home] Resolved parkId:', parkId);
                          this.fetchContractsForPark(parkId);
                      } else {
                          console.error('[Home] Could not resolve parkId from parques response');
                          this.parkAdminError = 'No se pudo identificar el parque del usuario';
                          this.isLoadingParkAdminData = false;
                      }
                  })
                  .catch(err => {
                      console.error('[Home] Error fetching parques:', err);
                      this.parkAdminError = 'Error al obtener información del parque';
                      this.isLoadingParkAdminData = false;
                  });
          });
      },
      fetchContractsForPark(parkId) {
          const API_BASE_URL = 'https://empresa-service.intrare.app';
          
          const config = {
              method: 'get',
              url: `${API_BASE_URL}/security/parks/${parkId}/contracts/`,
              headers: {
                  'Content-Type': 'application/json',
                  'authorization': `Token ${store.getters.getToken}`
              }
          };
          
          import('axios').then(axios => {
              axios.default(config)
                  .then(resp => {
                      console.log('[Home] Park contracts response:', resp.data);
                      // Filtrar el contrato ACTIVE
                      const contractsArray = resp.data.contracts || [];
                      const activeContract = contractsArray.find(contract => contract.status === 'ACTIVE');
                      
                      if (activeContract) {
                          this.parkAdminContract = activeContract;
                          // Si hay contrato activo, obtener guardias en caseta
                          this.fetchActiveCasetaGuards(parkId);
                      } else {
                          this.parkAdminContract = null;
                          this.isLoadingParkAdminData = false;
                      }
                  })
                  .catch(err => {
                      console.error('[Home] Error fetching park contracts:', err);
                      const errorDetail = err.response && err.response.data && err.response.data.detail
                          ? err.response.data.detail
                          : 'Error al obtener contratos de seguridad';
                      this.parkAdminError = errorDetail;
                      this.isLoadingParkAdminData = false;
                  });
          });
      },
      fetchActiveCasetaGuards(parkId) {
          const API_BASE_URL = 'https://empresa-service.intrare.app';
          const config = {
              method: 'get',
              url: `${API_BASE_URL}/security/caseta-guards/?park=${parkId}`,
              headers: {
                  'Content-Type': 'application/json',
                  'authorization': `Token ${store.getters.getToken}`
              }
          };
          
          import('axios').then(axios => {
              axios.default(config)
                  .then(resp => {
                      console.log('[Home] Caseta guards response:', resp.data);
                      this.parkAdminGuards = resp.data || [];
                      this.isLoadingParkAdminData = false;
                  })
                  .catch(err => {
                      console.error('[Home] Error fetching caseta guards:', err);
                      this.parkAdminGuards = [];
                      this.isLoadingParkAdminData = false;
                  });
          });
      }
  }
};
</script>

<style scoped>
.home-container {
    position: relative;
    margin: -16px;
    padding: 0;
    min-height: calc(100vh - 64px); 
    width: calc(100% + 32px);
    overflow-x: hidden;
}
.dashboard-scroll-container {
    min-height: 100%;
}

.dashboard-overlay {
    position: fixed;   
    top: 64px;         
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 0;       
    pointer-events: none;
}

.dashboard-content {
    position: relative;
    z-index: 1; 
    min-height: 100%;
    padding-bottom: 48px;
}

.dashboard-card {
    background-color: rgba(255, 255, 255, 0.95) !important; 
    backdrop-filter: blur(5px);
}

.trans-card {
     transition: transform 0.3s;
}
.trans-card:hover {
    transform: translateY(-5px);
}

.transparent-toggle {
    background-color: rgba(255,255,255,0.2) !important;
}
.display-3 {
    font-size: 4rem !important;
}

.stat-block {
    padding: 8px 4px;
}
.stat-block + .stat-block {
    border-left: 1px solid rgba(0,0,0,0.08);
}
.stat-label {
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: #757575;
    margin-bottom: 4px;
}
.stat-value {
    font-size: 1.9rem;
    font-weight: 700;
    line-height: 1.1;
}
.stat-block--available .stat-value {
    color: #388e3c;
}
.stat-block--occupied .stat-value {
    color: #d32f2f;
}

/* Wallpaper welcome screen */
.wallpaper-scrim {
    position: absolute;
    inset: 0;
    background: linear-gradient(160deg, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.15) 100%);
    z-index: 1;
}

/* Greeting header — used in all dashboard containers */
.home-greeting-header {
    text-shadow: 0 2px 8px rgba(0,0,0,0.55);
    animation: fadeInUp 0.5s ease both;
}
.home-greeting-label {
    font-size: 1.5rem;
    font-weight: 400;
    letter-spacing: 1px;
    opacity: 0.9;
    margin-bottom: 4px;
}
.home-greeting-name {
    font-size: 2.6rem;
    font-weight: 700;
    line-height: 1.15;
    margin-bottom: 8px;
}
.home-greeting-date {
    font-size: 1rem;
    font-weight: 300;
    opacity: 0.85;
    letter-spacing: 0.5px;
}
@keyframes fadeInUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
}
.rounded-xl {
    border-radius: 16px !important;
}
</style>
